// Material UI Library
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import FormHelperText from '@mui/material/FormHelperText';

// Translation Library
import { useTranslation } from 'react-i18next';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const governorateOptionsEn = {
  aleppo: "Aleppo",
  damascus: "Damascus",
  rif_dimashq: "Rif Dimashq",
  daraa: "Daraa",
  al_suwayda: "Al‑Suwayda",
  hama: "Hama",
  homs: "Homs",
  latakia: "Latakia",
  al_hasakah: "Al‑Hasakah",
  al_raqqah: "Al‑Raqqah",
  idlib: "Idlib",
  tartus: "Tartus",
  al_quneitra: "Al‑Quneitra",
  deir_ez_zor: "Deir ez Zor"
};

const governorateOptionsAr = {
  aleppo: "حلب",
  damascus: "دمشق",
  rif_dimashq: "ريف دمشق",
  daraa: "درعا",
  al_suwayda: "السويداء",
  hama: "حماة",
  homs: "حمص",
  latakia: "اللاذقية",
  al_hasakah: "الحسكة",
  ah_raqqah: "الرقة",
  idlib: "إدلب",
  tartus: "طرطوس",
  al_quneitra: "القنيطرة",
  deir_ez_zor: "دير الزور"
};


// make the object as Array and take the keys [key1, key2, key3,...]
const governorateEn = Object.keys(governorateOptionsEn);
const governorateAr = Object.keys(governorateOptionsAr);

export default function City({formData, handleChange, errorsData}) {
    const { t,i18n } = useTranslation();

  return (
    <>
      <FormControl className="flex-1">
        <InputLabel error={errorsData.city}>{t("city")}</InputLabel>
        <Select
            error={errorsData.city}
            name='city'
            value={formData.city}
            onChange={handleChange}
            input={<OutlinedInput label={t("city")} />}
            renderValue={(selected) =>{
              return selected ? (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {i18n.language === "en" ? <Chip label={governorateOptionsEn[selected]} /> : <Chip label={governorateOptionsAr[selected]} />}
                  </Box>
              ) : (
                  <></>
              )}
            }
            MenuProps={MenuProps}
        >
        {i18n.language === "en" 
        ?(
          governorateEn.map((key) => (
            <MenuItem key={key} value={key}>
              {governorateOptionsEn[key]}
            </MenuItem>
          ))
        )
        :(
          governorateAr.map((key) => (
            <MenuItem key={key} value={key}>
              {governorateOptionsAr[key]}
            </MenuItem>
          ))
        )
        }
        </Select>
        {errorsData.city ? (
        <FormHelperText sx={{ color: 'error.main' }}>{t("please_select_one_of_cities")}</FormHelperText>
        ): ""}
      </FormControl>
    </>
  );
}
